import React from 'react'
import { Link } from 'react-router-dom'

const MissingPersonsComponent = ({ moviePersons, Personswikis }) => (
  <>
    {moviePersons && moviePersons.length > 0 && (
      <>
        <div className='mandatory'>
          {moviePersons.length} persons are missing and they are
        </div>
        <div
          className='mandatory'
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          {moviePersons.map((e, index) => (
            <div key={index}>
              <span>
                {index + 1}. Name: {e.name_En},
              </span>
              <div>
                <span>personWikiURL: {e.personWikiURL}</span>
              </div>
            </div>
          ))}
          <Link
            data-toggle='tooltip'
            title={'MultiplePersons'}
            to={`/MultiplePersons?${Personswikis}`}
            target='_blank'
          >
            <button type='button' className='btn btn-primary'>
              Add Missing Persons
            </button>
          </Link>
        </div>
      </>
    )}
  </>
)

export default MissingPersonsComponent
